module.exports = __webpack_public_path__ + "static/media/Webonboardingsvg720.8f169495.m4v";